import { useLang } from "@/context/LanguageContext";
import { t } from "@/data/translations";
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from "@/components/ui/accordion";
import { motion } from "framer-motion";

export default function FAQ() {
  const { lang } = useLang();
  const faq = t.faq[lang];

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-16 md:py-28">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <p className="text-[10px] sm:text-xs uppercase tracking-[0.2em] font-semibold text-[#FF3B30] mb-3 sm:mb-4" data-testid="faq-overline">
          FAQ
        </p>
        <h1
          data-testid="faq-title"
          className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold tracking-tighter leading-none text-[#0A0B10] mb-8 sm:mb-12"
        >
          {faq.title}
        </h1>
      </motion.div>

      <Accordion type="single" collapsible data-testid="faq-accordion">
        {faq.items.map((item, i) => (
          <AccordionItem
            key={i}
            value={`item-${i}`}
            data-testid={`faq-item-${i}`}
            className="border-b border-[#0A0B10] rounded-none"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${i}`}
              className="text-left font-heading text-sm sm:text-base font-medium text-[#0A0B10] py-4 sm:py-6 hover:no-underline hover:text-[#FF3B30]"
            >
              {item.q}
            </AccordionTrigger>
            <AccordionContent data-testid={`faq-content-${i}`} className="text-xs sm:text-sm text-[#666666] leading-relaxed pb-4 sm:pb-6">
              {item.a}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
